
// import checkTigger from '@/utils/check.tigger.js';

let Base64 = require('js-base64').Base64;
export default {
  components: {
    // checkTigger
  },
  data() {
    return {
      email: "",
      pwd: "",
      btn_txt: "登录",
      is_remember: false, //下次自动登录
      active: 0, //0是账户登录，1是子账户登录
      loginData: {}, //子账户登录
    }
  },
  methods: {
    changeTab(e) {
      console.log(e)
      this.active = e
    },
    forgetPassword() {
      this.$router.push({
        path: "/ForgetPassword"
      });
    },
    remember() {
      this.is_remember = localStorage.getItem("is_remember");
      this.is_remember = this.is_remember == "true" ? true : false;
      if (this.is_remember) {
        this.email = Base64.decode(localStorage.getItem("email"));
        this.pwd = Base64.decode(localStorage.getItem("pwd"));
        if (this.email && this.pwd) {
          this.login();
        }
      }
    },
    login() {
      if (this.btn_txt === "登录中...") {
        return
      }
      if (this.active == 1) { //子账户登录
        if(!this.loginData.name){
          this.$Message.warning('请输入公司名称');
          return false;
        }
        if(!this.loginData.client_code){
          this.$Message.warning('请输入客户编号');
          return false;
        }
        if(!this.loginData.pwd){
          this.$Message.warning('请输入密码');
          return false;
        }
        this.btn_txt = "登录中...";

        this.$axios.get("/client/login/code", {
          params: this.loginData
        }).then(res => {
          localStorage.setItem('login_type',this.active)
          if (res.success) {
            localStorage.setItem("token", res.data);
            localStorage.setItem("client_code", this.loginData.client_code); //子账户client_code
            localStorage.setItem('client_name_code',this.loginData.client_code +' ' + this.loginData.name)
            this.$axios.defaults.headers.token = res.data;
            this.$router.replace({
              path: '/Home'
            });
          } else {
            this.btn_txt = "登录";
          }
        })
      } else { //主账号登录
        if (!this.email) {
          this.$Message.warning('请输入用户名');
          return false;
        }
        if (!this.pwd) {
          this.$Message.warning('请输入密码');
          return false;
        }
        let loginData = {
          email: this.email,
          pwd: this.pwd
        }
        this.btn_txt = "登录中...";

        this.$axios.get("/client/login", {
          params: loginData
        }).then(res => {
          localStorage.setItem('login_type',this.active)
          if (res.success) {
            localStorage.setItem("token", res.data);
            // localStorage.setItem('user_name', this.email);
            this.$axios.defaults.headers.token = res.data;
            localStorage.removeItem('client_code')
            localStorage.removeItem('client_name_code')
            this.$router.replace({
              path: '/Home'
            });
          } else {
            this.btn_txt = "登录";
          }
        })
      }
    },
  },
  created() {
    this.remember();
  }
}



// WEBPACK FOOTER //
// ./src/pages/web/login/main.js